module.exports = __webpack_public_path__ + "e55198d6fcd57630f0617639e2f6da90.woff2";


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/themes/fonts/National2Web-Light.woff2
// module id = 2510
// module chunks = 17